'use client'

import { DUR } from '@/animations/settings/vars'
import {
  Typo3SectionSpotHeadlessTeam,
  Typo3SectionSpotHeadlessTeam_Item
} from '@/types/typo3'
import {
  Button,
  CardTeam,
  Container,
  Section,
  SectionHeaderContent
} from '@/ui/components'
import { convertToSlug, getTitleTag } from '@/utils'
import { useLenis } from 'lenis/react'
import { memo } from 'react'
interface Props {
  data: Typo3SectionSpotHeadlessTeam
}

const SpotHeadlessTeam = ({ data }: Props) => {
  const items = data.items

  // Grouping data by category, including items without categories
  const groupedData: { [key: string]: Typo3SectionSpotHeadlessTeam_Item[] } =
    items.reduce(
      (acc, person) => {
        if (person?.categories && person?.categories?.length > 0) {
          person?.categories.forEach((category) => {
            if (!acc[category.title]) {
              acc[category.title] = []
            }
            acc[category.title].push(person)
          })
        } else {
          if (!acc['No Category']) {
            acc['No Category'] = []
          }
          acc['No Category'].push(person)
        }
        return acc
      },
      {} as { [key: string]: Typo3SectionSpotHeadlessTeam_Item[] }
    )

  //hooks
  const lenis = useLenis()

  return (
    <Section data={data} className="s-spotheadless-team py-none">
      <SectionHeaderContent
        as={getTitleTag(data?.titleLayout)}
        description={data?.subtitle}
        titleLayout={data?.titleLayout}
      >
        {data?.title}
      </SectionHeaderContent>
      {Object.keys(groupedData).length > 1 && (
        <Container anim="fade-in">
          <div className={''}>
            {Object.keys(groupedData).map(
              (category, i) =>
                category !== 'No Category' && (
                  <Button
                    key={i?.toString()}
                    as="div"
                    variant="secondary"
                    className={''}
                    nextLink={false}
                    onClick={() => {
                      lenis?.scrollTo(`#${convertToSlug(category)}`, {
                        duration: DUR.goldenRatio,
                        offset: -100
                      })
                    }}
                  >
                    {category}
                  </Button>
                )
            )}
          </div>
        </Container>
      )}
      {Object.entries(groupedData).map(([category, items], i) => (
        <div className={''} key={i?.toString()} id={convertToSlug(category)}>
          {/* <SectionHeaderContent as={getTitleTag(data?.titleLayout)}>
            {category !== 'No Category' && category}
          </SectionHeaderContent> */}
          <Container anim="fade-in" className="py-md">
            <div
              className={
                'gap-y-md gap-xs grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
              }
            >
              {items.map((item, index) => (
                <CardTeam
                  className={''}
                  key={index?.toString()}
                  image={item.photo}
                  name={`${item.firstname} ${item.lastname}`}
                  role={item.role}
                  email={item.email}
                  phone={item.phone}
                  link={item.link}
                  hoverImage={item.photoHover}
                  hoverVideo={item.videoHover}
                />
              ))}
            </div>
          </Container>
        </div>
      ))}
    </Section>
  )
}

export default memo(SpotHeadlessTeam)
